import { dayjs } from "@/core/utils/date";

export interface ReportCalendar {
  period_type: "weekly" | "biweekly" | "monthly" | "custom";
  /** 0 is Sunday, 1 Monday. */
  week_starts_on: number;
  /**
   * The first day of any one pay period (YYYY-MM-DD); every other period is
   * counted from it in steps of 14 days. Required for biweekly.
   */
  period_anchor_date?: string | null;
  /** IANA name; null means the business's own. */
  timezone: string | null;
  timezone_is_business_default?: boolean;
}

export const PERIOD_TYPE_LABEL: Record<ReportCalendar["period_type"], string> =
  {
    weekly: "Weekly",
    biweekly: "Biweekly pay periods",
    monthly: "Monthly",
    custom: "Custom dates",
  };

export const WEEKDAYS = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const describeCalendar = (calendar: ReportCalendar) => {
  if (calendar.period_type === "weekly")
    return `Weekly, ${WEEKDAYS[calendar.week_starts_on]} to ${WEEKDAYS[(calendar.week_starts_on + 6) % 7]}`;
  if (calendar.period_type === "biweekly" && calendar.period_anchor_date)
    return `Biweekly pay periods from ${dayjs(calendar.period_anchor_date).format("ddd, MMM D")}`;
  return PERIOD_TYPE_LABEL[calendar.period_type];
};
